export type CustomAyanamsha = { name: string; method: 'epoch' | 'offset'; degrees?: number; referenceDate?: string; baseMode?: string; offsetDegrees?: number };
export type AyanamshaSettings = { version: 0 | 1; mode: string; custom?: CustomAyanamsha };
export function chartAyanamshaSettings(chart: any): AyanamshaSettings | null {
  if (!chart) return null;
  return chart.calculationData?.ayanamshaSettings || { version: 0, mode: chart.calculationData?.ayanamshaMode || chart.chartSettings?.ayanamshaMode || chart.ayanamshaMode || 'LAHIRI' };
}
export function dmsDegrees(degrees: string, minutes: string, seconds: string): number {
  if (![degrees, minutes, seconds].every(value => /^\d+(?:\.\d+)?$/.test(value.trim()))) throw new Error('Enter valid degrees, minutes and seconds.');
  const [d, m, s] = [degrees, minutes, seconds].map(Number);
  if (!Number.isInteger(d) || !Number.isInteger(m) || d >= 360 || m >= 60 || s >= 60) throw new Error('Degrees: 0–359; minutes: 0–59; seconds: 0–59.999.');
  return d + m / 60 + s / 3600;
}
export function toDms(value: number) {
  const totalSeconds = Math.round(Math.abs(value || 0) * 3600 * 1e6) / 1e6;
  const d = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds - d * 3600) / 60);
  const s = Math.round((totalSeconds - d * 3600 - m * 60) * 1e6) / 1e6;
  return [String(d), String(m), String(s)];
}
export function buildCustomAyanamsha(name: string, method: 'epoch' | 'offset', value: number, referenceDate: string, baseMode: string): CustomAyanamsha {
  if (!name.trim() || name.trim().length > 60) throw new Error('Enter a name of up to 60 characters.');
  if (!Number.isFinite(value) || Math.abs(value) >= 360 || (method === 'epoch' && value < 0)) throw new Error('Enter a valid degree value below 360.');
  if (method === 'offset') return { name: name.trim(), method, baseMode, offsetDegrees: value };
  const iso = referenceDate.trim().replace(' ', 'T');
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?$/.test(iso)) throw new Error('Use YYYY-MM-DD HH:mm:ss for the reference date/time in UTC.');
  const normalized = iso.length === 16 ? iso + ':00' : iso;
  const date = new Date(normalized + 'Z');
  if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0,19) !== normalized) throw new Error('Enter a valid reference date and time.');
  return { name: name.trim(), method, degrees: value, referenceDate: date.toISOString() };
}
